import axios from 'axios'
import { store } from '@store/store'
import { logout } from '@services/auth.service'
import { toast } from 'react-toastify'

export const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'
const api = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'cs',
  },
})

api.interceptors.request.use(
  (config) => {
    const state = store.getState()
    const token = state.auth.token

    if (!config.url?.endsWith('/login/')) {
      if (token) {
        config.headers.Authorization = `${token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      store.dispatch(logout())
    }
    return Promise.reject(error)
  }
)

api.interceptors.response.use(undefined, function axiosRetryInterceptor(error) {
  if (!error.response) {
    // If the server is probably unreachable if there's no response
    toast.error('Problém s připojením. Zkuste akci později')
  } else if (error.response.status === 500) {
    // Handle Internal Server Error
    toast.error(error)
  }
  return Promise.reject(error)
})

export default api
